import { Stack } from 'braid-design-system';

import { FaqAccordion } from 'src/components/FaqAccordion/FaqAccordion';
import { faqs } from 'src/views/PackagesPage/components/FaqContent';
import { PackagesContainer } from 'src/views/PackagesPage/components/Packages';

const ProductsTab = () => (
  <Stack space="xlarge">
    <PackagesContainer />

    <FaqAccordion faqs={faqs} />
  </Stack>
);

export default ProductsTab;
